import "../../index.scss";
//https://heroicons.com/
export const IconHome = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    />
  </svg>
);

export const IconComputer = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

export const IconSetting = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
    />
  </svg>
);

export const IconAlarm = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
    />
  </svg>
);

export const IconCalendar = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
  </svg>
);

export const IconLogout = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    />
  </svg>
);

export const IconSun = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
    />
  </svg>
);

export const IconMoon = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
    />
  </svg>
);

export const IconForm = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
);

export const IconAlert = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
    />
  </svg>
);

export const IconAlertFilled = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
    />
  </svg>
);

export const IconAlertTrue = (
  <svg width="30" height="30" className="c-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.10645 18.8952C5.88426 19.673 7.15705 19.673 7.93487 18.8952L5.10645 16.0668C4.32863 16.8446 4.32156 18.1103 5.10645 18.8952Z"
      fill="#fefefe"
    />
    <path
      d="M13.5914 18.8952L17.127 15.3597C19.2978 13.1889 19.9554 10.2119 18.4139 7.70879L18.8947 7.22796C19.4816 6.64106 19.4816 5.69354 18.8947 5.10664C18.3078 4.51974 17.3603 4.51974 16.7734 5.10664L16.2926 5.58747C13.7823 4.03891 10.8196 4.69651 8.64167 6.8744L5.10614 10.4099H3.28181C2.39085 10.4099 1.9383 11.4847 2.56763 12.1141L11.8802 21.4267C12.5095 22.056 13.5914 21.6105 13.5914 20.7196V18.8952Z"
      fill="#fefefe"
    />
    <circle cx="19" cy="10" r="2.5" fill="red" stroke="white" />
  </svg>
);

export const IconMenu = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

export const IconEye = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
);

export const IconEyeOutline = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
    />
  </svg>
);

export const IconTrash = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
);

export const IconNewTrash = (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V6C13 4.9 12.1 4 11 4H3C1.9 4 1 4.9 1 6V16ZM4 6H10C10.55 6 11 6.45 11 7V15C11 15.55 10.55 16 10 16H4C3.45 16 3 15.55 3 15V7C3 6.45 3.45 6 4 6ZM10.5 1L9.79 0.29C9.61 0.11 9.35 0 9.09 0H4.91C4.65 0 4.39 0.11 4.21 0.29L3.5 1H1C0.45 1 0 1.45 0 2C0 2.55 0.45 3 1 3H13C13.55 3 14 2.55 14 2C14 1.45 13.55 1 13 1H10.5Z"
      fill="#EE4629"
    />
  </svg>
);

export const IconCollaborator = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
    />
  </svg>
);

export const IconProjects = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
    />
  </svg>
);
export const IconCheck = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);

export const IconAdd = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
  </svg>
);

export const IconArrowBottom = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconArrowTop = (
  <svg width="14" height="8" viewBox="0 0 14 8" className="c-icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
    />
  </svg>
);

export const IconGear = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

export const IconResetPassword = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
    />
  </svg>
);

export const IconSearch = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);

export const IconEdit = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
  </svg>
);

export const IconInvoice = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
    />
  </svg>
);

export const IconX = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const IconEmail = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

export const IconGift = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
    />
  </svg>
);

export const IconPencil = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
    />
  </svg>
);

export const IconPencilRevert = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" viewBox="0 0 20 20" fill="currentColor">
    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
  </svg>
);

export const IconClock = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

export const IconUpload = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
  </svg>
);

export const IconLink = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 19H6C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5H11C11.55 5 12 4.55 12 4C12 3.45 11.55 3 11 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13C21 12.45 20.55 12 20 12C19.45 12 19 12.45 19 13V18C19 18.55 18.55 19 18 19ZM14 4C14 4.55 14.45 5 15 5H17.59L8.46 14.13C8.07 14.52 8.07 15.15 8.46 15.54C8.85 15.93 9.48 15.93 9.87 15.54L19 6.41V9C19 9.55 19.45 10 20 10C20.55 10 21 9.55 21 9V3H15C14.45 3 14 3.45 14 4Z"
      fill="#2B3A4B"
    />
  </svg>
);

export const IconDownload = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

export const IconClockTimer = (
  <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.3334 0.666992H5.66673C5.30007 0.666992 5.00007 0.966992 5.00007 1.33366C5.00007 1.70033 5.30007 2.00033 5.66673 2.00033H8.3334C8.70007 2.00033 9.00007 1.70033 9.00007 1.33366C9.00007 0.966992 8.70007 0.666992 8.3334 0.666992ZM7.00007 9.33366C7.36673 9.33366 7.66673 9.03366 7.66673 8.66699V6.00033C7.66673 5.63366 7.36673 5.33366 7.00007 5.33366C6.6334 5.33366 6.3334 5.63366 6.3334 6.00033V8.66699C6.3334 9.03366 6.6334 9.33366 7.00007 9.33366ZM11.6867 4.92699L12.1867 4.42699C12.4401 4.17366 12.4467 3.75366 12.1867 3.49366L12.1801 3.48699C11.9201 3.22699 11.5067 3.23366 11.2467 3.48699L10.7467 3.98699C9.7134 3.16033 8.4134 2.66699 7.00007 2.66699C3.80007 2.66699 1.08007 5.30699 1.00007 8.50699C0.9134 11.8937 3.62673 14.667 7.00007 14.667C10.3201 14.667 13.0001 11.9803 13.0001 8.66699C13.0001 7.25366 12.5067 5.95366 11.6867 4.92699ZM7.00007 13.3337C4.42007 13.3337 2.3334 11.247 2.3334 8.66699C2.3334 6.08699 4.42007 4.00033 7.00007 4.00033C9.58007 4.00033 11.6667 6.08699 11.6667 8.66699C11.6667 11.247 9.58007 13.3337 7.00007 13.3337Z"
      fill="white"
    />
  </svg>
);

export const IconQuestion = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99967 0.833008C4.93967 0.833008 0.833008 4.93967 0.833008 9.99967C0.833008 15.0597 4.93967 19.1663 9.99967 19.1663C15.0597 19.1663 19.1663 15.0597 19.1663 9.99967C19.1663 4.93967 15.0597 0.833008 9.99967 0.833008ZM9.99967 17.333C5.95717 17.333 2.66634 14.0422 2.66634 9.99967C2.66634 5.95717 5.95717 2.66634 9.99967 2.66634C14.0422 2.66634 17.333 5.95717 17.333 9.99967C17.333 14.0422 14.0422 17.333 9.99967 17.333ZM9.08301 13.6663H10.9163V15.4997H9.08301V13.6663ZM10.5588 4.53634C8.67051 4.26134 7.00217 5.42551 6.49801 7.09384C6.33301 7.62551 6.73634 8.16634 7.29551 8.16634H7.47884C7.85467 8.16634 8.15717 7.90051 8.28551 7.55217C8.57884 6.73634 9.44967 6.17717 10.3938 6.37884C11.2647 6.56217 11.9063 7.41467 11.833 8.30384C11.7413 9.53217 10.348 9.79801 9.58717 10.9438C9.58717 10.953 9.57801 10.953 9.57801 10.9622C9.56884 10.9805 9.55968 10.9897 9.55051 11.008C9.46801 11.1455 9.38551 11.3013 9.32134 11.4663C9.31217 11.4938 9.29384 11.5122 9.28467 11.5397C9.27551 11.558 9.27551 11.5763 9.26634 11.6038C9.15634 11.9155 9.08301 12.2913 9.08301 12.7497H10.9163C10.9163 12.3647 11.0172 12.0438 11.173 11.7688C11.1913 11.7413 11.2005 11.7138 11.2188 11.6863C11.2922 11.558 11.3838 11.4388 11.4755 11.3288C11.4847 11.3197 11.4938 11.3013 11.503 11.2922C11.5947 11.1822 11.6955 11.0813 11.8055 10.9805C12.6855 10.1463 13.8772 9.46801 13.6297 7.71718C13.4097 6.12217 12.1538 4.77467 10.5588 4.53634Z"
      fill="#fff"
    />
  </svg>
);

export const IconRightArrow = (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
    <path
      d="M1.28957 9.88047L5.16957 6.00047L1.28957 2.12047C0.89957 1.73047 0.89957 1.10047 1.28957 0.710469C1.67957 0.320469 2.30957 0.320469 2.69957 0.710469L7.28957 5.30047C7.67957 5.69047 7.67957 6.32047 7.28957 6.71047L2.69957 11.3005C2.30957 11.6905 1.67957 11.6905 1.28957 11.3005C0.90957 10.9105 0.89957 10.2705 1.28957 9.88047Z"
      fill="#545D69"
    />
  </svg>
);

export const IconLeftArrow = (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.70998 9.88047L2.82998 6.00047L6.70998 2.12047C7.09998 1.73047 7.09998 1.10047 6.70998 0.710469C6.31998 0.320469 5.68998 0.320469 5.29998 0.710469L0.70998 5.30047C0.31998 5.69047 0.31998 6.32047 0.70998 6.71047L5.29998 11.3005C5.68998 11.6905 6.31998 11.6905 6.70998 11.3005C7.08998 10.9105 7.09998 10.2705 6.70998 9.88047Z"
      fill="#545D69"
    />
  </svg>
);

export const IconLeftArrowVersion2 = (
  <svg width="16" height="16" viewBox="0 0 16 16" className="c-icon" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0005 6.99973H3.83047L8.71047 2.11973C9.10047 1.72973 9.10047 1.08973 8.71047 0.699727C8.32047 0.309727 7.69047 0.309727 7.30047 0.699727L0.710469 7.28973C0.320469 7.67973 0.320469 8.30973 0.710469 8.69973L7.30047 15.2897C7.69047 15.6797 8.32047 15.6797 8.71047 15.2897C9.10047 14.8997 9.10047 14.2697 8.71047 13.8797L3.83047 8.99973H15.0005C15.5505 8.99973 16.0005 8.54973 16.0005 7.99973C16.0005 7.44973 15.5505 6.99973 15.0005 6.99973Z"
      fill="#2B3A4B"
    />
  </svg>
);

export const IconLeftArrowVersion3 = (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z"
      clip-rule="evenodd"
    />
  </svg>
);

export const IconGestion = (
  <svg className="c-icon icon-gestion" width="20" height="25" viewBox="0 0 18 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H10.82C10.4 0.84 9.3 0 8 0C6.7 0 5.6 0.84 5.18 2H2C0.9 2 0 2.9 0 4V19C0 20.1 0.9 21 2 21H8.11C7.52 20.43 7.04 19.75 6.69 19H2V4H4V5C4 6.1 4.9 7 6 7H10C11.1 7 12 6.1 12 5V4H14V9.08C14.71 9.18 15.38 9.39 16 9.68V4C16 2.9 15.1 2 14 2ZM8 4C7.45 4 7 3.55 7 3C7 2.45 7.45 2 8 2C8.55 2 9 2.45 9 3C9 3.55 8.55 4 8 4ZM13 11C10.24 11 8 13.24 8 16C8 18.76 10.24 21 13 21C15.76 21 18 18.76 18 16C18 13.24 15.76 11 13 11ZM14.29 18L12.64 16.35C12.55 16.26 12.49 16.13 12.49 16V13.51C12.49 13.23 12.71 13.01 12.99 13.01C13.27 13.01 13.49 13.23 13.49 13.51V15.8L14.99 17.3C15.19 17.5 15.19 17.81 14.99 18.01C14.8 18.2 14.49 18.2 14.29 18Z" />
  </svg>
);

export const IconGraph = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
    />
  </svg>
);

export const IconArrosDifs = (
  <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.70047 9.9007L2.80047 6.0007L6.70047 2.1007C7.09047 1.7107 7.09047 1.0907 6.70047 0.700703C6.31047 0.310703 5.69047 0.310703 5.30047 0.700703L0.710469 5.2907C0.320469 5.6807 0.320469 6.3107 0.710469 6.7007L5.30047 11.3007C5.69047 11.6907 6.31047 11.6907 6.70047 11.3007C7.09047 10.9107 7.09047 10.2907 6.70047 9.9007ZM13.3005 9.9007L17.2005 6.0007L13.3005 2.1007C12.9105 1.7107 12.9105 1.0907 13.3005 0.700703C13.6905 0.310703 14.3105 0.310703 14.7005 0.700703L19.2905 5.2907C19.6805 5.6807 19.6805 6.3107 19.2905 6.7007L14.7005 11.3007C14.3105 11.6907 13.6905 11.6907 13.3005 11.3007C12.9105 10.9107 12.9105 10.2907 13.3005 9.9007Z"
      fill="#2B3A4B"
    />
  </svg>
);

export const IconPeopleProjects = (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5 7C15.88 7 16.99 5.88 16.99 4.5C16.99 3.12 15.88 2 14.5 2C13.12 2 12 3.12 12 4.5C12 5.88 13.12 7 14.5 7ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM14.5 9C12.67 9 9 9.92 9 11.75V13C9 13.55 9.45 14 10 14H19C19.55 14 20 13.55 20 13V11.75C20 9.92 16.33 9 14.5 9ZM7 8C4.67 8 0 9.17 0 11.5V13C0 13.55 0.45 14 1 14H7V11.75C7 10.9 7.33 9.41 9.37 8.28C8.5 8.1 7.66 8 7 8Z"
      fill="#2B3A4B"
    />
  </svg>
);

export const IconCheckBold = (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5975 2.30177L6.10034 9.61509C5.83202 9.87683 5.48478 10 5.12176 10C4.77452 10 4.42728 9.87683 4.15896 9.61509L0.40248 5.96613C-0.13416 5.42725 -0.13416 4.58045 0.40248 4.05697C0.93912 3.53349 1.823 3.53349 2.35964 4.05697L5.12176 6.75135L11.6404 0.39261C12.177 -0.13087 13.0609 -0.13087 13.5975 0.39261C14.1342 0.931486 14.1342 1.77829 13.5975 2.30177Z"
      fill="#2B3A4B"
    />
  </svg>
);

export const IconXBorder = (
  <svg width="15" height="14" className="c-icon" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.50065 0.333008C3.81398 0.333008 0.833984 3.31301 0.833984 6.99967C0.833984 10.6863 3.81398 13.6663 7.50065 13.6663C11.1873 13.6663 14.1673 10.6863 14.1673 6.99967C14.1673 3.31301 11.1873 0.333008 7.50065 0.333008ZM10.3673 9.86634C10.1073 10.1263 9.68732 10.1263 9.42732 9.86634L7.50065 7.93967L5.57398 9.86634C5.31398 10.1263 4.89398 10.1263 4.63398 9.86634C4.37398 9.60634 4.37398 9.18634 4.63398 8.92634L6.56065 6.99967L4.63398 5.07301C4.37398 4.81301 4.37398 4.39301 4.63398 4.13301C4.89398 3.87301 5.31398 3.87301 5.57398 4.13301L7.50065 6.05967L9.42732 4.13301C9.68732 3.87301 10.1073 3.87301 10.3673 4.13301C10.6273 4.39301 10.6273 4.81301 10.3673 5.07301L8.44065 6.99967L10.3673 8.92634C10.6207 9.17968 10.6207 9.60634 10.3673 9.86634Z"
      fill="#EE4629"
    />
  </svg>
);

export const IconXBorderJSX = ({ width = "15" }) => {
  return (
    <svg width={width} height={width} className="c-icon" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.50065 0.333008C3.81398 0.333008 0.833984 3.31301 0.833984 6.99967C0.833984 10.6863 3.81398 13.6663 7.50065 13.6663C11.1873 13.6663 14.1673 10.6863 14.1673 6.99967C14.1673 3.31301 11.1873 0.333008 7.50065 0.333008ZM10.3673 9.86634C10.1073 10.1263 9.68732 10.1263 9.42732 9.86634L7.50065 7.93967L5.57398 9.86634C5.31398 10.1263 4.89398 10.1263 4.63398 9.86634C4.37398 9.60634 4.37398 9.18634 4.63398 8.92634L6.56065 6.99967L4.63398 5.07301C4.37398 4.81301 4.37398 4.39301 4.63398 4.13301C4.89398 3.87301 5.31398 3.87301 5.57398 4.13301L7.50065 6.05967L9.42732 4.13301C9.68732 3.87301 10.1073 3.87301 10.3673 4.13301C10.6273 4.39301 10.6273 4.81301 10.3673 5.07301L8.44065 6.99967L10.3673 8.92634C10.6207 9.17968 10.6207 9.60634 10.3673 9.86634Z"
        fill="#EE4629"
      />
    </svg>
  );
};

export const IconAddImage = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.02 5H19V2.98C19 2.44 18.56 2 18.02 2H17.99C17.44 2 17 2.44 17 2.98V5H14.99C14.45 5 14.01 5.44 14 5.98V6.01C14 6.56 14.44 7 14.99 7H17V9.01C17 9.55 17.44 10 17.99 9.99H18.02C18.56 9.99 19 9.55 19 9.01V7H21.02C21.56 7 22 6.56 22 6.02V5.98C22 5.44 21.56 5 21.02 5ZM16 9.01V8H14.99C14.46 8 13.96 7.79 13.58 7.42C13.21 7.04 13 6.54 13 5.98C13 5.62 13.1 5.29 13.27 5H5C3.9 5 3 5.9 3 7V19C3 20.1 3.9 21 5 21H17C18.1 21 19 20.1 19 19V10.72C18.7 10.89 18.36 11 17.98 11C16.89 10.99 16 10.1 16 9.01ZM15.96 19H6C5.59 19 5.35 18.53 5.6 18.2L7.58 15.57C7.79 15.29 8.2 15.31 8.4 15.59L10 18L12.61 14.52C12.81 14.26 13.2 14.25 13.4 14.51L16.35 18.19C16.61 18.52 16.38 19 15.96 19Z"
      fill="#2B3A4B"
    />
  </svg>
);

export const IconSave = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.59 3.59C17.21 3.21 16.7 3 16.17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V7.83C21 7.3 20.79 6.79 20.41 6.42L17.59 3.59ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM13 9H7C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5H13C14.1 5 15 5.9 15 7C15 8.1 14.1 9 13 9Z"
      fill="#2B3A4B"
    />
  </svg>
);

export const IconSwitch = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 12a1 1 0 102 0V6.414l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L5 6.414V12zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
      fill="#2B3A4B"
    />
  </svg>
);

export const IconFilter = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    />
  </svg>
);

export const IconSpreadsheet = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
    />
  </svg>
);

export const IconCalendarWithPencil = (
  <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3889 27.3125H3.07639C2.32639 27.3125 1.68056 27.0625 1.13889 26.5625C0.638889 26.0208 0.388889 25.3958 0.388889 24.6875V6C0.388889 5.25 0.638889 4.625 1.13889 4.125C1.68056 3.58333 2.32639 3.3125 3.07639 3.3125H4.38889V0.6875H7.07639V3.3125H17.7014V0.6875H20.3889V3.3125H21.7014C22.4514 3.3125 23.0764 3.58333 23.5764 4.125C24.1181 4.625 24.3889 5.25 24.3889 6V14H21.7014V11.3125H3.07639V24.6875H12.3889V27.3125ZM25.8889 20.625L26.8264 19.6875C27.0764 19.4375 27.2014 19.125 27.2014 18.75C27.2014 18.375 27.0764 18.0625 26.8264 17.8125L25.8889 16.875C25.6389 16.625 25.3264 16.5 24.9514 16.5C24.5764 16.5 24.2639 16.625 24.0139 16.875L23.0764 17.8125L25.8889 20.625ZM24.9514 21.625L17.8889 28.6875H15.0764V25.8125L22.1389 18.75L24.9514 21.625Z"
      fill="#333333"
    />
  </svg>
);

export const IconCheckCircle = (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" className="c-icon" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.6663 12.9267V14C25.6649 16.5158 24.8503 18.9638 23.3439 20.9788C21.8375 22.9938 19.7202 24.4679 17.3076 25.1812C14.895 25.8945 12.3165 25.8089 9.95656 24.937C7.59664 24.0651 5.58177 22.4538 4.21246 20.3432C2.84315 18.2327 2.19276 15.7361 2.3583 13.2257C2.52383 10.7153 3.49642 8.32571 5.131 6.41325C6.76559 4.50079 8.97459 3.16794 11.4286 2.6135C13.8825 2.05906 16.45 2.31272 18.748 3.33666M25.6663 4.66666L13.9997 16.345L10.4997 12.845"
      stroke="#039855"
      stroke-width="2.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconKey = (
  <svg width="24" height="24" viewBox="0 0 24 24" className="c-icon" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 7.5L19 4M21 2L19 4L21 2ZM11.39 11.61C11.9064 12.1195 12.3168 12.726 12.5978 13.3948C12.8787 14.0635 13.0246 14.7813 13.0271 15.5066C13.0295 16.232 12.8884 16.9507 12.6119 17.6213C12.3355 18.2919 11.9291 18.9012 11.4162 19.4141C10.9033 19.9271 10.294 20.3334 9.62333 20.6099C8.95271 20.8864 8.23403 21.0275 7.50866 21.025C6.7833 21.0226 6.06557 20.8767 5.39682 20.5958C4.72807 20.3148 4.1215 19.9043 3.61203 19.388C2.61016 18.3507 2.05579 16.9614 2.06832 15.5193C2.08085 14.0772 2.65928 12.6977 3.67903 11.678C4.69877 10.6583 6.07824 10.0798 7.52032 10.0673C8.96241 10.0548 10.3517 10.6091 11.389 11.611L11.39 11.61ZM11.39 11.61L15.5 7.5L11.39 11.61ZM15.5 7.5L18.5 10.5L22 7L19 4L15.5 7.5Z"
      stroke="#121926"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconError = (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7034 2.63998C10.9264 2.7324 11.129 2.86786 11.2997 3.03861L16.961 8.6997C17.1319 8.87038 17.2674 9.07308 17.3599 9.29619C17.4524 9.51931 17.5 9.75847 17.5 10C17.5 10.2415 17.4524 10.4807 17.3599 10.7038C17.2674 10.9269 17.1319 11.1296 16.961 11.3003L11.2997 16.9614C11.129 17.1321 10.9264 17.2676 10.7034 17.36C10.4804 17.4524 10.2414 17.5 10 17.5C9.75861 17.5 9.51958 17.4524 9.29658 17.36C9.07358 17.2676 8.87096 17.1321 8.70032 16.9614L3.039 11.3003C2.86813 11.1296 2.73258 10.9269 2.64009 10.7038C2.5476 10.4807 2.5 10.2415 2.5 10C2.5 9.75847 2.5476 9.51931 2.64009 9.29619C2.73258 9.07308 2.86813 8.87038 3.039 8.6997L8.70032 3.03861C8.87096 2.86786 9.07358 2.7324 9.29658 2.63998C9.51958 2.54757 9.75861 2.5 10 2.5C10.2414 2.5 10.4804 2.54757 10.7034 2.63998ZM9.35098 11.5666C9.52311 11.7388 9.75657 11.8355 10 11.8355C10.2434 11.8355 10.4769 11.7388 10.649 11.5666C10.8211 11.3944 10.9178 11.161 10.9178 10.9175V6.32768C10.9178 6.08422 10.8211 5.85073 10.649 5.67858C10.4769 5.50642 10.2434 5.40971 10 5.40971C9.75657 5.40971 9.52311 5.50642 9.35098 5.67858C9.17885 5.85073 9.08214 6.08422 9.08214 6.32768V10.9175C9.08214 11.161 9.17885 11.3944 9.35098 11.5666ZM9.35098 14.3205C9.52311 14.4926 9.75657 14.5894 10 14.5894C10.2434 14.5894 10.4769 14.4926 10.649 14.3205C10.8211 14.1483 10.9178 13.9149 10.9178 13.6714C10.9178 13.4279 10.8211 13.1944 10.649 13.0223C10.4769 12.8501 10.2434 12.7534 10 12.7534C9.75657 12.7534 9.52311 12.8501 9.35098 13.0223C9.17885 13.1944 9.08214 13.4279 9.08214 13.6714C9.08214 13.9149 9.17885 14.1483 9.35098 14.3205Z"
      fill="#B42318"
    />
  </svg>
);

export const IconCash = (
  <svg xmlns="http://www.w3.org/2000/svg" className="c-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

// export const IconHome = (
// <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
// </svg>
// );

export const IconTriangleError = (
  <svg width="20" height="20" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="-2" y="-3" width="24" height="24" fill="#F04438" />
  </svg>
);
